import * as API from '../utilities/api';

export const RECEIVE_DISCOUNTS = 'RECEIVE_DISCOUNTS';
export const SELECT_DISCOUNT = 'SELECT_DISCOUNT';
export const REMOVE_PROMO = 'REMOVE_PROMO';
export const RESET_DISCOUNTS = 'RESET_DISCOUNTS';


export function fetchDiscounts(overwrite) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      if (state.discount.discountsData === null || state.discount.discountsData === undefined || overwrite) {
        if (state.bookingLocation.selectedLocationId === null) {
          reject('No locationId for discount selection')
        }
        else {
          API.getDiscounts(state.bookingLocation.selectedLocationId)
            .then(result => {
              dispatch(receiveDiscounts(result));
              resolve();
            })
            .catch(error => {
              console.error('Failed to get discounts info: ' + error);
              reject(error);
            });
        }
      }
      else resolve();
    });
  }
}

export function receiveDiscounts(discounts) {
  return {
    type: RECEIVE_DISCOUNTS,
    discounts
  };
}

export function selectDiscount(discount) {
  return {
    type: SELECT_DISCOUNT,
    discount
  };
}

export function removePromo() {
  return {
    type: REMOVE_PROMO
  };
}

// export function resetDiscounts() {
//   return {
//     type: RESET_DISCOUNTS
//   };
// }
